<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="900px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="
                        openData.title == '查看' || openData.title == '审核'
                    "
                    label-position="left"
                    label-width="110px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="标题：">
                                <el-input
                                    style="width: 145%"
                                    v-model="formData.title"
                                    class="inputban"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="上传视频: " prop="video">
                                <div
                                    class="threestyleimg"
                                    style="position: relative"
                                >
                                    <div class="threestyleimgtu">
                                        <el-input
                                            disabled
                                            v-model="formData.video"
                                            style="width: 186px"
                                        ></el-input>
                                    </div>
                                    <div class="threestyleimgbtn">
                                        <el-button
                                            style="
                                                position: absolute;
                                                left: 186px;
                                                top: -60px;
                                                border: 1px solid #ccc;
                                            "
                                            ><i
                                                class="el-icon-back"
                                                @click="remove"
                                                >删除</i
                                            ></el-button
                                        >
                                        <el-button
                                            @click="push"
                                            style="
                                                position: absolute;
                                                left: 260px;
                                                top: -60px;
                                                border: 1px solid #ccc;
                                            "
                                            ><i class="el-icon-upload2"></i>上传
                                        </el-button>
                                    </div>
                                    <el-dialog
                                        label-width="110px"
                                        :append-to-body="true"
                                        title="上传视频"
                                        :visible.sync="showpush"
                                        width="500px"
                                        class="uploadvidio"
                                        style="margin-top: 50px; height: 600px"
                                    >
                                        <div class="threestyleimg">
                                            <div class="file-upload">
                                                <div
                                                    class="file-upload-text"
                                                    style="padding: 5px"
                                                >
                                                    <i class="el-icon-plus"></i
                                                    >视频上传
                                                </div>
                                                <input
                                                    name="upfile"
                                                    class="file-upload-input"
                                                    id="upfile"
                                                    type="file"
                                                    @change="videohttp"
                                                />
                                            </div>
                                            <div
                                                class="threestyleimgtu"
                                                style=""
                                            >
                                                <form>
                                                    <fieldset
                                                        style="
                                                            border-radius: 5px;
                                                        "
                                                    >
                                                        <legend
                                                            style="
                                                                color: seagreen;
                                                            "
                                                        >
                                                            视频信息
                                                        </legend>
                                                        <video
                                                            :src="
                                                                formData.video
                                                            "
                                                            controls
                                                            style="
                                                                width: 400px;
                                                                height: 240px;
                                                            "
                                                        ></video>
                                                    </fieldset>
                                                </form>
                                            </div>
                                        </div>
                                    </el-dialog>
                                </div>
                            </el-form-item>
                            <el-form-item label="发布时间：">
                                <el-date-picker
                                    style="width: 145%"
                                    class="inputban"
                                    v-model="formData.releaseTime"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :offset="1">
                            <el-form-item prop="photo" align="left">
                                <el-upload
                                    :action="baseUrls"
                                    :show-file-list="false"
                                    :on-success="
                                        (file, fileList) => {
                                            handleAvatarSuccess(
                                                file,
                                                fileList,
                                                'add'
                                            )
                                        }
                                    "
                                    :before-upload="beforeAvatarUpload"
                                >
                                    <div>
                                        <div
                                            class="avatar"
                                            v-if="formData.photo != ''"
                                        >
                                            <img
                                                :src="
                                                    formData.photo ==
                                                    '../../assets/img/user.png'
                                                        ? ''
                                                        : formData.photo
                                                "
                                            />
                                        </div>
                                        <i
                                            v-else
                                            class="el-icon-plus avatar_uploader avatar-uploader-icon"
                                        ></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="发布内容：" prop="content">
                        <el-input
                            v-model.trim="formData.content"
                            :autosize="{ minRows: 2 }"
                            type="textarea"
                            placeholder="请输入内容"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="公开性质：" prop="publicNature">
                        <el-checkbox-group v-model="formData.publicNature">
                            <el-checkbox label="0">公众号</el-checkbox>
                            <el-checkbox label="1">APP</el-checkbox>
                            <el-checkbox label="2">显示屏</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="
                        openData.title == '审核' ||
                        (openData.title == '查看' &&
                            formData.auditFlag != '') ||
                        (openData.title == '查看' && formData.auditFlag == 0)
                    "
                    :disabled="openData.title == '查看'"
                    label-position="left"
                    label-width="120px"
                    ref="examine"
                    :model="examineData"
                    :rules="examineRules"
                >
                    <el-form-item label="审核结果" prop="auditFlag">
                        <el-radio-group v-model="formData.auditFlag">
                            <el-radio label="2">审核通过</el-radio>
                            <el-radio label="0">审核不通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核意见：" prop="failureReason">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model="formData.failureReason"
                            placeholder="请输入审核意见"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '详情'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { uploadOnlineStudyPhoto } from "@/api/partyReportedcopyhttp"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"
import baseURL from "@/api/baseURL"

export default {
    props: ["openData"],
    components: {
        quillEditor,
    },
    data() {
        return {
            baseUrls: "",
            baseUrl: "",
            examineData: {},
            examineRules: {},
            formData: {
                title: "",
                content: "",
                publicNature: [],
                releaseTime: "",
                failureReason: "",
                auditFlag: "1",
                photo: "",
                video: "",
            },
            formDataRules: {},
            orgList: [],
            levelList: [],
            showpush: false,
        }
    },
    created() {
        this.baseUrl = baseURL + "/controller/uploadVotePic/info/uploadOrgLife"
        this.baseUrls =
            baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
        this.formData = {
            title: "",
            content: "",
            publicNature: [],
            releaseTime: "",
            failureReason: "",
            auditFlag: "1",
            photo: "",
            video: "",
        }
        if (this.openData.title == "新增") {
        } else {
            this.dataInfos()
        }
    },
    methods: {
        remove() {
            console.log(1)
            this.addform.enclosure = ""
            this.addform.enclosure = ""
        },
        // 详情页信息
        dataInfos() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/newsConsulting/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        self.formData = res.content
                        self.formData.publicNature = res.content.publicNature.split(
                            ","
                        )
                        self.formData.auditFlag = String(res.content.auditFlag)
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        push() {
            this.showpush = true
        },
        // 上传视频
        async videohttp(e) {
            console.log(e)
            console.log(e.target.files[0])
            const res = await uploadOnlineStudyPhoto(e.target.files[0])
            console.log(res.content)
            this.$set(this.formData, "video", res.content)
        },
        // 上传图片前的判断
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 5
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 5MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            this.$set(this.formData, "photo", res.content)
        },
        handleSubmit() {
            if (
                this.openData.title == "新增" ||
                this.openData.title == "编辑"
            ) {
                this.$refs.formData.validate((valid) => {
                    if (valid) {
                        if (
                            this.openData.title == "新增" ||
                            this.openData.title == "编辑"
                        ) {
                            let url = ""
                            let data = { ...this.formData }
                            data.publicNature = data.publicNature.toString()
                            data.type = 2
                            url = "/ypt/admin/newsConsulting/info/save"
                            this.$http
                                .request({
                                    url: url,
                                    method: "POST",
                                    data: {
                                        ...data,
                                    },
                                })
                                .then((res) => {
                                    if (res.code == 200) {
                                        this.$message.success(res.message)
                                    } else {
                                        this.$message.error(res.message)
                                    }
                                    // this.$emit("cancleService", true)
                                    this.$emit("cancleAddress", true)
                                    this.openData.state = false
                                })
                        }
                    }
                })
            } else {
                this.$refs.formData.validate((valid) => {
                    if (valid) {
                        let url = ""
                        let data = { ...this.formData }
                        console.log(this.formData)
                        data.publicNature = data.publicNature.toString()
                        data.type = 2
                        url = "/ypt/admin/newsConsulting/info/toexamine"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message)
                                } else {
                                    his.$message.error(res.message)
                                }
                                // this.$emit("cancleService", true)
                                this.$emit("cancleAddress", true)
                                this.openData.state = false
                            })
                    }
                })
            }
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 200px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}
.avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    img {
        width: 200px;
        height: 200px;
        line-height: 200px;
        display: block;
    }
}
.threestyleimg {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;

    .threestyleimgtu {
        width: 80%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
    }

    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        margin-top: 20px;

        // background-color: green;
        display: flex;
        // justify-content: center;
        // align-items: center;

        position: relative;

        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }

        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
</style>